import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalStorage } from '../../utils/utilityCustomHooks';
import useStyles from './DiscountBanner.styles';
import { DISCOUNT_APPLIED_BANNER_TEXT } from '../../utils/constants';
const DiscountBanner = () => {
    var _a;
    const { classes } = useStyles();
    const { getFromLocalStorage } = useLocalStorage();
    // Get discount data from localStorage
    const discountByURLData = getFromLocalStorage('discountByUrl');
    const ctdKeyFromStorage = getFromLocalStorage('ctdKey');
    // Get ctdKey from URL parameters
    let ctdKey = null;
    if (typeof globalThis !== 'undefined') {
        const params = new URLSearchParams((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.search);
        ctdKey = params.get('ctdKey');
    }
    // Determine if banner should be displayed
    const shouldDisplayBanner = ctdKeyFromStorage &&
        (ctdKeyFromStorage === (discountByURLData === null || discountByURLData === void 0 ? void 0 : discountByURLData.ctdKey) || !ctdKey || ctdKey === '') &&
        (discountByURLData === null || discountByURLData === void 0 ? void 0 : discountByURLData.code) &&
        (discountByURLData === null || discountByURLData === void 0 ? void 0 : discountByURLData.isApplied) !== false; // Check isApplied flag
    // Don't render if conditions not met
    if (!shouldDisplayBanner) {
        return null;
    }
    const bannerText = DISCOUNT_APPLIED_BANNER_TEXT.replace('{name}', (discountByURLData === null || discountByURLData === void 0 ? void 0 : discountByURLData.name) || '');
    return (_jsx("div", { className: classes.discountBlock, children: (discountByURLData === null || discountByURLData === void 0 ? void 0 : discountByURLData.code) && (_jsxs("div", { className: classes.discountContainer, children: [_jsx("div", { className: classes.iconContainer, children: _jsx("div", { className: classes.appliedIcon }) }), _jsx("span", { className: classes.discountText, children: bannerText })] })) }));
};
export default DiscountBanner;
